export const SET_FOR_SALE_LISTINGS = 'SET_FOR_SALE_LISTINGS';
export const SET_MY_LISTINGS = 'SET_MY_LISTINGS';
export const SET_HISTORY_LISTINGS = 'SET_HISTORY_LISTINGS';

export const GET_LISTING = 'GET_LISTING';
